import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import EditIcon from '@mui/icons-material/Edit';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { toast } from 'react-toastify';

import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';


const ProfileDetails = () => {
  const authToken = localStorage.getItem('authToken');
  const [profileData, setProfileData] = useState(null);
  const [editable, setEditable] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  let errorMsg = '';

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await fetch('https://beta.flowlogic.com/api/users/profile/', {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
          },
        });

        
        const result = await response.json();

           if (response.ok && result.data) {
        setProfileData(result.data);
        setProfileData(result.data);

           localStorage.setItem("eula_accepted", result.data.eula_accepted);

        console.log("eula_accepted login:", result.data.eula_accepted);
           }
            else {
        setErrorMessage(result.message || "Failed to fetch profile data");
      }

      } catch (error) {
        setErrorMessage('Failed to fetch profile data');
      }
    };

    fetchProfile();
  }, [authToken]);

  

  const handleInputChange = (field, value) => {
    setProfileData(prev => ({ ...prev, [field]: value }));
  };


const handleUpdate = async () => {
  try {
    const response = await fetch('https://beta.flowlogic.com/api/users/update/', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`,
      },
      body: JSON.stringify(profileData),
    });

    const result = await response.json();

    if (!response.ok) {
      let errorMsg = 'Update failed.';

      // 🔴 Case 1: String-style errors (e.g. "['Invalid phone number']")
      if (typeof result.errors === 'string') {
        try {
          const parsedErrors = JSON.parse(result.errors.replace(/'/g, '"'));
          if (Array.isArray(parsedErrors)) {
            parsedErrors.forEach((msg) => toast.error(msg));
            errorMsg = parsedErrors.join(', ');
          } else {
            toast.error(result.errors);
            errorMsg = result.errors;
          }
        } catch {
          toast.error(result.errors);
          errorMsg = result.errors;
        }
      }

      // 🔴 Case 2: Object-style errors (e.g. { first_name: ["This field..."] })
      else if (typeof result.errors === 'object') {
        const firstKey = Object.keys(result.errors)[0];
        const firstError = result.errors[firstKey];

        if (Array.isArray(firstError)) {
          toast.error(`${firstKey}: ${firstError[0]}`);
          errorMsg = `${firstKey}: ${firstError[0]}`;
        } else if (typeof firstError === 'string') {
          toast.error(`${firstKey}: ${firstError}`);
          errorMsg = `${firstKey}: ${firstError}`;
        } else {
          toast.error(`${firstKey}: Unknown error`);
          errorMsg = `${firstKey}: Unknown error`;
        }
      }

      // // Generic message
      // if (result.message) {
      //   toast.error(result.message);
      // }

      setErrorMessage(errorMsg);
      return;
    }

    // // ✅ Success case
    // if (result.data) {
    //   setProfileData(result.data);
    // }

    toast.success(result.message || 'Profile updated successfully');
    setEditable(false);
    setErrorMessage('');

  } catch (error) {
    console.error('Update failed:', error);
    toast.error('Network error while updating profile');
    setErrorMessage('Network error while updating profile');
  }
};


  // if (!profileData) {
  //   return <div>Loading...</div>;
  // }
  if (!profileData) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }
  

  return (
    <div className="profile-details register-container">
        <ToastContainer position="top-right" autoClose={3000} />
      <div className="profile-header">
        <div className="profile-pic-container">
          {/* <img src="/assets/Profile-pic.png" alt="Profile" className="profile-pic" /> */}
          <div className="edit-icon" onClick={() => setEditable(!editable)}>
            {/* ✏️ */}
            <EditIcon style={{ fontSize: 20, color: '#007bff' }} />
          </div>
        </div>
        <h2>Profile</h2>
      </div>

      {errorMessage && <div className="error">{errorMessage}</div>}

      <form onSubmit={(e) => { e.preventDefault(); handleUpdate(); }}>
        <div className="form-group">
          <label>First Name</label>
          {editable ? (
            <input
              type="text"
              value={profileData.first_name || ''}
              onChange={(e) => handleInputChange('first_name', e.target.value)}
            />
          ) : (
            <p>{profileData.first_name || '-'}</p>
          )}
        </div>

        {/* <div className="form-group">
          <label>Last Name</label>
          {editable ? (
            <input
              type="text"
              value={profileData.last_name || ''}
              onChange={(e) => handleInputChange('last_name', e.target.value)}
            />
          ) : (
            <p>{profileData.last_name || '-'}</p>
          )}
        </div> */}

        <div className="form-group">
          <label>Phone Number</label>
          {editable ? (
            <input
              type="text"
              value={profileData.phone_number || ''}
              maxLength={10}
              onChange={(e) => handleInputChange('phone_number', e.target.value)}
            />
          ) : (
            <p>{profileData.phone_number || '-'}</p>
          )}
        </div>

                <div className="form-group">
          <label>Email</label>
           <p>{profileData.email || '-'}</p>
            {/* <input
              type="text"
              value={profileData.phone_number || ''}
              maxLength={10}
              onChange={(e) => handleInputChange('phone_number', e.target.value)}
            disabled='fasle'            /> */}
     
        </div>

        <div className="form-group">
          <label>Investment Profile</label>
          {editable ? (
            <select
              value={profileData.inv_type || ''}
              // onChange={(e) => handleInputChange('invest_type', e.target.value)}
                onChange={(e) => handleInputChange('inv_type', e.target.value)} 
              style={{ backgroundColor: 'white' }} 
            >
              {/* <option value="">Select Investment Type</option> */}
              <option value="individual">Individual</option>
              <option value="re_agent">Real Estate Agent</option>
              <option value="analyst">Analyst</option>
              <option value="inv_firm">Investment Firm</option>
              <option value="prop_manager">Property Manager</option>
            </select>
          ) : (
            <p>{profileData.inv_type || '-'}</p>
          )}
        </div>

        <div className="form-group">
          <label>Investment Experience</label>
          {editable ? (
            <select
              value={profileData.inv_exp || ''}
              onChange={(e) => handleInputChange('invest_exp', e.target.value)}
              //  onChange={(e) => handleInputChange('inv_exp', e.target.value)}
              style={{ backgroundColor: 'white' }} 
            >
              {/* <option value="">Select Investment Experience</option> */}
              <option value="new">New</option>
              <option value="below3">Below 3 years</option>
              <option value="below5">Below 5 years</option>
              <option value="above5">Above 5 years</option>
            </select>
          ) : (
            <p>{profileData.inv_exp || '-'}</p>
          )}
        </div>

        {editable && (
          <Button type="submit" variant="success" className="mt-3">Update</Button>
        )}
      </form>
    </div>
  );
};

export default ProfileDetails;
